import React, { ReactNode } from 'react';
import classNames from 'classnames';

import styles from './styles.module.scss';

type Props = {
  aboveContent?: React.ReactNode;
  children: ReactNode;
};

const ScreenBottomBar: React.FC<Props> = ({ children, aboveContent }) => (
  <div className="w-full fixed left-0 bottom-0 z-50">
    {aboveContent}
    <div
      className={classNames('bg-white pb-8 md:pb-4', styles.screenBottomBar)}
    >
      <div className="px-5 pt-4">
        <div className="md:max-w-[800px] md:mx-auto flex items-center justify-between gap-2">
          {children}
        </div>
      </div>
    </div>
  </div>
);

export default ScreenBottomBar;
